import env from '@config/env';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const shouldLog = (level: LogLevel): boolean => {
  if (env.isProd && level === 'debug') return false;
  return true;
};

const formatMessage = (level: LogLevel, message: string, context?: string): string =>
  `[${level.toUpperCase()}]${context ? ` [${context}]` : ''} ${message}`;

export const logger = {
  debug: (message: string, data?: unknown, context?: string) => {
    if (shouldLog('debug')) {
      console.warn(formatMessage('debug', message, context), data ?? '');
    }
  },
  info: (message: string, data?: unknown, context?: string) => {
    if (shouldLog('info')) {
      console.warn(formatMessage('info', message, context), data ?? '');
    }
  },
  warn: (message: string, data?: unknown, context?: string) => {
    if (shouldLog('warn')) {
      console.warn(formatMessage('warn', message, context), data ?? '');
    }
  },
  error: (message: string, error?: unknown, context?: string) => {
    if (shouldLog('error')) {
      console.error(formatMessage('error', message, context), error ?? '');
    }
  },
};
